import type { JSX } from "react";

/**
 * Preise laufen in Mono mit tabellarischen Ziffern, sonst springen sie beim
 * Neuberechnen im Warenkorb (StyleGuide 3).
 *
 * Gerechnet wird in der kleinsten Währungseinheit; geteilt wird erst hier, für die
 * Anzeige.
 */
export function Money({
  cents,
  currency = "EUR",
}: {
  cents: number;
  currency?: string;
}): JSX.Element {
  const formatted = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency,
  }).format(cents / 100);
  return <span className="num">{cents === 0 ? "Kostenlos" : formatted}</span>;
}
